import Cookies from 'js-cookie';
import { CSRF_TOKEN } from '../constants/tokens';

export function removeTokenCookies() {
  Cookies.remove(CSRF_TOKEN);
}
